import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  overrides: {
    MuiFormHelperText: {
      root: {
        fontKerning: 'none',
        letterSpacing: 0,

        '&$error': {
          fontFamily: 'DINNextLTPro-Regular',
          fontKerning: 'none',
          fontSize: 14,
          fontStyle: 'Italic',
          letterSpacing: 0
        }
      }
    },
    MuiFormLabel: {
      root: {
        fontKerning: 'none',
        letterSpacing: 0
      }
    },
    MuiInput: {
      root: {
        fontKerning: 'none',
        letterSpacing: 0
      }
    }
  },
  palette: {
    action: {
      disabled: '#ffffff',
      disabledBackground: '#dddddd'
    },
    error: { main: '#ff9602' },
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#f14b49'
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: '#0066ff',
      main: '#60c6aa'
      // dark: will be calculated from palette.secondary.main,
      // contrastText: '#ffcc00'
    }
  },
  typography: {}
});

export default theme;
